import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { Note } from './notes-util.ts';
import type { NotesByCreator_notesByCreator_nodes as NoteNodeResponse } from './__types__/GetNotesQuery.ts';

/**
 * Takes a note GQL payload and transforms into a Note object
 *
 * @param {object} currentPage
 * @returns {object} Note
 */

export const transformToNote = (payload: NoteNodeResponse | undefined): Note => {
	if (!payload) return {} as Note;

	const { body, ...noteData } = payload;
	let adf;
	// This try catch has been added temporarily because plaintext non-adf/json was added to the DB
	// TODO: remove once we sanitize all of those test entries

	try {
		adf = body ? (JSON.parse(body) as ADFEntity) : undefined;
	} catch (e) {
		adf = undefined;
	}

	return {
		...noteData,
		adf,
	};
};
